import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import Chip from 'material-ui/Chip';
import Divider from 'material-ui/Divider';
import { List, ListItem } from 'material-ui/List';
import KeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight';
import './Experience.css';
import Avatar from 'material-ui/Avatar';
import asulogo from './img/asu-logo.png';
import './Projects.css';

class Projects extends Component {

    handleTouchTap(param) {
        switch (param) {
            case 'movievisualization': window.open('https://cips1.engineering.asu.edu/movie_analysis/', '_blank');
                break;
            case 'stackoverflow': window.open('http://35.167.233.0:3000/', '_blank');
                break;
            case 'sandman': window.open('http://sandman-js.appspot.com/', '_blank');
                break;
        }

    }

    render() {
        let leftPosition = this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open ? 200 : 0;

        const style = {
            height: '30px',
            textAlign: 'center',
            backgroundColor: '#1de9b6',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0,
            marginLeft: leftPosition,
        };

        const listStyle = {
            marginTop: '5px',
            marginBottom: '5px',
            paddingTop: '2px',
            paddingBottom: '2px',
            marginLeft: '0px',
            paddingLeft: '40px',
            fontFamily: "Raleway, sans-serif",
            lineHeight: 1.3
        };

        const subListStyle = {
            marginTop: '5px',
            marginBottom: '5px',
            paddingTop: '2px',
            paddingBottom: '2px',
            marginLeft: '25px',
            paddingLeft: '40px',
            fontFamily: "Raleway, sans-serif"
        }

        const chipsStyles = {
            chip: {
                margin: 4,
                backgroundColor: '#1de9b6',
                fontFamily: "Raleway, sans-serif",
                display: 'inline-block'
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap',
                marginBottom: '10px'
            },
        };

        const iconStyle = {
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '-2px',
            marginBottom: '2px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '0px',
            marginLeft: '0px',
            display: 'flex',
            height: 25,
            width: 25
        }

        const logoStyle = {
            float: 'right',
            marginTop: 20
        }

        return (
            <Grid className="Project" style={{ margin: 0, width: '100%', backgroundColor: '#efebe9' }}>
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ padding: 0 }}>
                        <Paper style={style} zDepth={1}
                            />
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Geospatial Hotspot Detection </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="Applied spatial statistics to spatial-temporal data to identify statistically significant hotspots using Spark SQL" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Determined top 50 pick-up locations for Yellow Cabs in NYC using Getis-Ord statistic over 1 billion records" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            Scala
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Hadoop
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Apache Spark
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Spark SQL
                                    </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Adaptive Navigation Support for Discussion Forum Posts </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="Developed Q&A website which dynamically presents massive discussion threaded data for smart navigation" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Incorporated Content-based & Collaborative filtering, Open Social user modeling to enhance user experience" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Designed wireframes and translated into dynamic, interactive, responsive website" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            React
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Redux
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Elasticsearch
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            PostgreSQL
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Spring MVC
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Bootstrap
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Highcharts.js
                                    </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Stack Overflow User Activity Monitor </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented an interactive social dashboard to allow users to monitor and compare Stack Overflow activities" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Created RESTful API that provides basic CRUD operations on user data" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Built chrome extension to track user Stack Overflow activities" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            React
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Node.JS
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Express.JS
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            D3.JS
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS
                                        </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Material-UI
                                        </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Brain Network(Connectome) based classification </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="A connectome is a comprehensive map of neural connections in the brain" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Classified human subjects according to gender and math capability based on the connectome" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Visually represented similarities and differences between any pair of connectivity graphs of brains" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented SVM, LR, decision tree classifiers and achieved ensemble accuracy of 78.56% " leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            Matlab
                                    </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Python
                                    </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Handwritten digit recognition </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="Classified images in Handwritten Digits Data using an ensemble of KNN, SVM, and Feed Forward Neural Network" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented SVM for multiclass and multilabel classification; KNN for classification; and K-means clustering" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="The entire ensemble of classifiers helped in achieving the accuracy of 95.23%" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            Matlab
                                    </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block', marginRight: 20 }}> Movie Data Analysis and Visualization</h2>

                                    <a href="https://cips1.engineering.asu.edu/movie_analysis/" target="_blank">
                                        View website
                                    </a>

                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="A visual dashboard that assists movie producers and investors in assembling a team of actors and directors" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Analyzed the IMDB data of over 5000 recent movies to dig out relevant insights" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Responsible for designing the dashboard mock-ups and interactive visualizations" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            JavaScript
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            jQuery
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Apache Solr
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            D3.js
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML5
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS3
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Bootstrap3
                                            </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block', marginRight: 20 }}> Stack Overflow User Activity Monitor </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented chrome extension to track users' activities on Stack Overflow" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented an interactive social dashboard that assists users to compare their Stack Overflow activities with other users" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Designed and developed RESTful API and database schema for collection and retrieval of user data" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            React
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Redux
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Node.js
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Express.js
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            D3.js
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Postgres
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML5
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS3
                                            </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Bootstrap3
                                            </Chip>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> DVIZ - Web analytics platform for hotel owners </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="A visualization dashboard that aids new/existing hotel owners to analyze:" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <List>
                                            <ListItem style={subListStyle} disabled={true} primaryText="Fluctuating future rates of nearby hotels" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                            <ListItem style={subListStyle} disabled={true} primaryText="Interesting nearby places to visit" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                            <ListItem style={subListStyle} disabled={true} primaryText="Availability of transportation from airport to hotel" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                            <ListItem style={subListStyle} disabled={true} primaryText="Number of tourists’ arrival and departure" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        </List>
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            JavaScript
                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            jQuery
                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Amadeus API
                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            D3.js
                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML5
                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS3
                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Bootstrap3
                                </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Secure Bank Website </h2>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="Designed, developed and maintained front-end for a secure bank website" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Implemented client-side security features to avoid XSS attacks, SQL Injection, and DOS attacks" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Used OAuth for authentication and authorization" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Developed a common User Interface for bank customers, employees, manager, admin" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            React
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Redux
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML5
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS3
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Bootstrap3
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            C#
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            MySQL
                                                </Chip>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#75ccb9' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block', marginRight: 20 }}> Sandman.js – A gesture recognition JavaScript library </h2>
                                    <a href="http://sandman-js.appspot.com/" target="_blank">
                                        View website
                                    </a>
                                    <List>
                                        <ListItem style={listStyle} disabled={true} primaryText="The library allows developers to incorporate customized gestures into their website" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Sampled gesture data using Linear Interpolation and Fourier Transform and built a decision tree classifier" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="1st prize in web application category at INC 2013, PICT" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                    <div style={chipsStyles.wrapper}>
                                        <Chip style={chipsStyles.chip}>
                                            JavaScript
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Python
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Django
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            MongoDB
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            Google App Engine
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            CSS3
                                                </Chip>
                                        <Chip style={chipsStyles.chip}>
                                            HTML5
                                                </Chip>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Grid>

        )
    }
}

const mapStateToProps = (state) => {
    const { browser, responsiveDrawer } = state;
    return {
        browser,
        responsiveDrawer
    };
};

export default connect(mapStateToProps, null)(Projects);


// WEBPACK FOOTER //
// ./src/Projects.js